import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import commonEs from './common.es.json';
import commonEn from './common.en.json';

import authEs from '@features/auth/i18n/es.json';
import authEn from '@features/auth/i18n/en.json';
import dashboardEs from '@features/dashboard/i18n/es.json';
import dashboardEn from '@features/dashboard/i18n/en.json';
import inboxEs from '@features/inbox/i18n/es.json';
import inboxEn from '@features/inbox/i18n/en.json';
import channelsEs from '@features/channels/i18n/es.json';
import channelsEn from '@features/channels/i18n/en.json';
import pricingEs from '@features/pricing/i18n/es.json';
import pricingEn from '@features/pricing/i18n/en.json';
import knowledgeEs from '@features/knowledge-base/i18n/es.json';
import knowledgeEn from '@features/knowledge-base/i18n/en.json';
import tokensCostsEs from '@features/tokens-costs/i18n/es.json';
import tokensCostsEn from '@features/tokens-costs/i18n/en.json';
import automationsEs from '@features/automations/i18n/es.json';
import automationsEn from '@features/automations/i18n/en.json';
import feedbackEs from '@features/feedback/i18n/es.json';
import feedbackEn from '@features/feedback/i18n/en.json';
import billingEs from '@features/billing/i18n/es.json';
import billingEn from '@features/billing/i18n/en.json';
import customersEs from '@features/customers/i18n/es.json';
import customersEn from '@features/customers/i18n/en.json';
import aiAgentsEs from '@features/ai-agents/i18n/es.json';
import aiAgentsEn from '@features/ai-agents/i18n/en.json';
import reportsEs from '@features/reports/i18n/es.json';
import reportsEn from '@features/reports/i18n/en.json';
import settingsEs from '@features/settings/i18n/es.json';
import settingsEn from '@features/settings/i18n/en.json';

export const SUPPORTED_LANGUAGES = ['es', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'es';

export const I18N_NAMESPACES = [
  'common',
  'auth',
  'dashboard',
  'inbox',
  'channels',
  'pricing',
  'knowledge',
  'tokensCosts',
  'automations',
  'feedback',
  'billing',
  'customers',
  'aiAgents',
  'reports',
  'settings',
] as const;
export type I18nNamespace = (typeof I18N_NAMESPACES)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    ns: I18N_NAMESPACES as unknown as string[],
    defaultNS: 'common',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'gretabot.lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
    resources: {
      es: {
        common: commonEs,
        auth: authEs,
        dashboard: dashboardEs,
        inbox: inboxEs,
        channels: channelsEs,
        pricing: pricingEs,
        knowledge: knowledgeEs,
        tokensCosts: tokensCostsEs,
        automations: automationsEs,
        feedback: feedbackEs,
        billing: billingEs,
        customers: customersEs,
        aiAgents: aiAgentsEs,
        reports: reportsEs,
        settings: settingsEs,
      },
      en: {
        common: commonEn,
        auth: authEn,
        dashboard: dashboardEn,
        inbox: inboxEn,
        channels: channelsEn,
        pricing: pricingEn,
        knowledge: knowledgeEn,
        tokensCosts: tokensCostsEn,
        automations: automationsEn,
        feedback: feedbackEn,
        billing: billingEn,
        customers: customersEn,
        aiAgents: aiAgentsEn,
        reports: reportsEn,
        settings: settingsEn,
      },
    },
  });

export default i18n;
